export type LevelObjective =
  | { type: "diamonds"; target: number }
  | { type: "combo"; target: number }
  | { type: "rare"; target: number };

export interface ObjectiveStats {
  diamonds: number;
  bestCombo: number;
  rareDiamonds: number;
}

export const objectiveValue = (objective: LevelObjective, stats: ObjectiveStats): number => {
  if (objective.type === "combo") return stats.bestCombo;
  if (objective.type === "rare") return stats.rareDiamonds;
  return stats.diamonds;
};

export const objectiveComplete = (objective: LevelObjective, stats: ObjectiveStats): boolean =>
  objectiveValue(objective, stats) >= objective.target;

export const objectiveProgress = (objective: LevelObjective, stats: ObjectiveStats): number =>
  Math.min(1, objectiveValue(objective, stats) / objective.target);

export const objectiveText = (objective: LevelObjective, stats: ObjectiveStats): string => {
  const remaining = Math.max(0, objective.target - objectiveValue(objective, stats));
  if (remaining === 0) return "Target complete";
  if (objective.type === "combo") return `Build a ${objective.target} combo - best ${stats.bestCombo}`;
  if (objective.type === "rare") {
    return `Collect ${remaining} more rare gem${remaining === 1 ? "" : "s"} before time runs out`;
  }
  return `Collect ${remaining} more diamond${remaining === 1 ? "" : "s"} before time runs out`;
};

export const objectiveName = (objective: LevelObjective): string => {
  if (objective.type === "combo") return `Reach combo ${objective.target}`;
  if (objective.type === "rare") return `Collect ${objective.target} rare gems`;
  return `Collect ${objective.target} diamonds`;
};
